import "../UserProfile.scss";
import { getBoardlist, getClassList, getSubjectList, getEducationalInterest, getCouresePreferences, UpdateCoursePrefernces, getLanguageList, getUserDetails, updateUserDetails, updateLanguage } from "../Services/UserProfile.sevice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useEffect, useRef, useState } from "react";
import { SelectButton } from 'primereact/selectbutton';
import { useFormik } from "formik";
import { EditCoursePrefernces } from "../Schema/UserProfile.schema";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from 'primereact/multiselect';
import { UpdateCoursePreferncesIntere } from "../Interfaces/Userprofile.interface";
import { toast } from "react-hot-toast";
import * as Yup from 'yup';
import { useAppDispatch } from "@Src/app/hooks";
import { setLanguageId, setLanguageName } from "@Src/app/reducers/auth/loginSlice";
import { setCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";


export const EditCoursesIndex = ({ setIsEdit, courseprefernces, canUpdateCoursePreferences }: any) => {
  const dispatch = useAppDispatch();
  const [languageList, setLanguageList] = useState<Array<any>>([])
  const [userDetails, setUserDetails] = useState<any>(null)
  const [boardlist, setBoardlist] = useState<Array<any>>([])
  const [classList, setclassList] = useState<Array<any>>([])
  const [subjectList, setsubjectList] = useState<Array<any>>([])
  const [eductinterest, seteductinterest] = useState<Array<any>>([])
  const [selectedClassName, setSelectedClassName] = useState<Array<any>>([])
  const classChangeSelection = useRef<string | null>(null);
  const subjectRequestId = useRef(0);

  const CoursePreference = Yup.object({
    languageListId: Yup.string().nullable().required("Please select a language"),
    classlistId: Yup.string().required("Please select class"),
    boardListId: Yup.string().required("Please select examination"),
    // educationInterestListId: Yup.number().nullable().required("Please select education interest"),
    subjectListId: Yup.array().min(1, 'Please select atleast one subject').required('Please select subjects'),
  })


  useEffect(() => {
    //   getcoursedata();
    setcoursepreferncedata(courseprefernces);
    LanguageListdata()
    Boardlistdata()
    ClassListdata()
    EducationalInterest()
    getUserDetailsData()
  }, [])




  const { handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, setFieldValue, setValues } = useFormik({
    initialValues: EditCoursePrefernces,
    validationSchema: CoursePreference,

    onSubmit: (e) => {
      updateLanguage(Number(e.languageListId));
      // dispatch(setLanguageId(Number(e.languageListId)));
      const langObj = languageList.find(l => l.Id == Number(e.languageListId));
      if (langObj) {
        dispatch(setLanguageName(langObj.Name));
      }
      // updateLanguage()
      updatecourseprefer(e as any)


    }
  })
  useEffect(() => {
    if (
      values.classlistId !== null &&
      values.classlistId !== '' &&
      values.boardListId !== null &&
      values.boardListId !== ''
    ) {
      const selectAllSubjects = classChangeSelection.current === String(values.classlistId);
      classChangeSelection.current = null;
      subjectlistdata(values.classlistId, values.boardListId, selectAllSubjects);
    } else {
      subjectRequestId.current += 1;
    }
  }, [values.classlistId, values.boardListId])

  useEffect(() => {
    if (values.boardListId != '') {
      ClassListdata();
    }
  }, [values.boardListId])


  // -------------------getting-existing-course-details-api-call-------------------  
  const getcoursedata = () => {
    getCouresePreferences().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setcoursepreferncedata(response?.data)
      }
    })
  }

  const setcoursepreferncedata = (data: any) => {
    let subjectIds: any[] = [];
    if (data?.['subjectDetails'] && data?.['subjectDetails'].length) {
      subjectIds = data?.['subjectDetails'].map((index: any) => { return index.Id });
    }
    setValues({
      languageListId: data?.['languageDetails'] && data?.['languageDetails'].length && data?.['languageDetails'][0]['Id'],
      classlistId: data?.['classDetails'] && data?.['classDetails'].length && data?.['classDetails'][0]['Id'],
      boardListId: data?.['boardDetails'] && data?.['boardDetails'].length && data?.['boardDetails'][0]['Id'],
      subjectListId: subjectIds,
      educationInterestListId: data?.['educationInterestDetails'] && data?.['educationInterestDetails'][0] && data?.['educationInterestDetails'][0]['Id']
    })
  }

  // -------------------classlist-api-call-------------------
  const ClassListdata = () => {
    let params = {
      boardId: values.boardListId
    }
    getClassList(params).then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setclassList(response?.data)
        let classId = Number(courseprefernces?.['classDetails'][0]['Id'],)
        onChangeClass(classId, response?.data)
      }
    }).catch((error: any) => {
      console.log(error)
    })

  }

  // -------------------Boardlist-api-call-------------------
  const Boardlistdata = () => {


    getBoardlist().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setBoardlist(response?.data)

      }
    }).catch((error: any) => {
      console.log(error)
    })

  }

  // -------------------subjectlist-api-call-------------------

  const subjectlistdata = (classId: string | number, boardId: string | number, selectAll = false) => {
    const requestId = ++subjectRequestId.current;
    let params = {
      classId,
      boardId
    }
    getSubjectList(params).then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS && requestId === subjectRequestId.current) {
        setsubjectList(response?.data)
        if (selectAll) {
          setFieldValue('subjectListId', response.data.map((subject: any) => subject.Id))
        }
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  // -------------------EducationalInterest-api-call-------------------
  const EducationalInterest = () => {
    getEducationalInterest().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        seteductinterest(response?.data)
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  // -------------------LanguageList-api-call-------------------
  const LanguageListdata = () => {
    getLanguageList().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setLanguageList(response?.data)
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  // -------------------getUserDetails-api-call-------------------
  const getUserDetailsData = () => {
    getUserDetails().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setUserDetails(response?.data[0])
        setFieldValue('languageListId', response?.data[0]?.LanguageId)
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }



  // -------------------sending-updated-course-prefernces-to-api-------------------
  const updatecourseprefer = (updatedata: UpdateCoursePreferncesIntere) => {
    const courseupdate: UpdateCoursePreferncesIntere = {
      "languageListId": [updatedata.languageListId],
      "classlistId": [updatedata.classlistId],
      "boardListId": [updatedata.boardListId],
      "subjectListId": updatedata.subjectListId,
      "educationInterestListId": updatedata.educationInterestListId > 0 ? [updatedata.educationInterestListId] : []
    }
    if (touched && isValid && userDetails) {
      const userPayload = {
        DOB: userDetails.DOB?.split('T')[0],
        Gender: userDetails.Gender,
        phoneNo: userDetails.PhoneNo,
        city: userDetails.City,
        stateId: userDetails.stateId,
        LanguageId: updatedata.languageListId,
        school: userDetails.School,
        NickName: userDetails.NickName,
        Address: userDetails.Address
      }

      Promise.all([
        UpdateCoursePrefernces(courseupdate),
        updateUserDetails(userPayload)
      ]).then(async () => {
        // Fetch updated data to sync with Redux
        try {
          const [prefResponse, userResponse] = await Promise.all([
            getCouresePreferences(),
            getUserDetails()
          ]);

          if (prefResponse.ResponseType === APIStatus.SUCCESS) {
            dispatch(setCoursePreferences(prefResponse.data));
          }
          if (userResponse.ResponseType === APIStatus.SUCCESS && userResponse.data?.[0]) {
            const langId = userResponse.data[0].LanguageId;
            dispatch(setLanguageId(langId));
            const langObj = languageList.find(l => l.Id == langId);
            if (langObj) {
              dispatch(setLanguageName(langObj.Name));
            }
          }
        } catch (error) {
          console.error("Failed to sync Redux after update", error);
        }

        toast.success('Details updated successfully!')
        setIsEdit(false)
      }).catch(() => {
        toast.error('Could not update. Please try again.')
      })
    }


  }

  const onChangeClass = (value: number, data?: any) => {
    let dataSelection: any;
    if (data && data.length) {
      dataSelection = data.find((element: any) => element.Id == value);

    } else {
      dataSelection = classList.find((element: any) => element.Id == value);
    }
    if (values.classlistId) {
      if (value == values.classlistId) {

      } else {
        setFieldValue('educationInterestListId', 0);
      }
    }
    setSelectedClassName(dataSelection?.Name);
    //subjectlistdata()
  }


  const onChangeBoard = (e: any) => {
    if (values.boardListId) {
      if (e.value == values.boardListId) {

      } else {
        setFieldValue('educationInterestListId', 0);
        setFieldValue('subjectListId', [])
        setFieldValue('classlistId', '');
      }
    }
    //subjectlistdata()
  }

  return (
    <>
      <div className="profile-input-card tw-bg-white tw-shadow-lg tw-rounded-2xl px-4 pb-4 pt-2 mt-2">
        <form onSubmit={handleSubmit}>
          <div>
            <div className="input-form-card">
              <div className="form-label-log">Choose Preferred Language <span className="mandiatory-star">*</span></div>
              <Dropdown
                className="prime-deopdown"
                placeholder="Please select your Language"
                value={values.languageListId}
                name="languageListId"
                onChange={(e) => {
                  handleChange(e);
                  // updateLanguage(e.value);
                  // dispatch(setLanguageId(e.value));
                  // const langObj = languageList.find(l => l.Id == e.value);
                  // if (langObj) {
                  //   dispatch(setLanguageName(langObj.Name));
                  // }
                }}
                options={languageList}
                optionLabel="Name" optionValue="Id"
                appendTo="self"

              />
              {errors.languageListId && touched.languageListId ?
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.languageListId}</p> : null}
            </div>
            <div className="input-form-card">
              <div className="form-label-log">Choose Target Exam <span className="mandiatory-star">*</span></div>
              <Dropdown
                className="prime-deopdown"
                placeholder="Please select your examination"
                value={values.boardListId}
                name="boardListId"
                onChange={(e) => { handleChange(e), onChangeBoard(e) }}
                options={boardlist}
                optionLabel="Name" optionValue="Id"
                disabled={!canUpdateCoursePreferences()}
                appendTo="self"

              />
              {errors.boardListId && touched.boardListId ?
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.boardListId}</p> : null}
            </div>
            <div className="input-form-card">
              <div className="form-label-log">Choose Your Class <span className="mandiatory-star">*</span></div>

              <Dropdown value={values.classlistId}
                className="prime-deopdown"
                name="classlistId"
                onChange={(e) => {
                  if (String(e.value) !== String(values.classlistId)) {
                    classChangeSelection.current = String(e.value);
                    setFieldValue('subjectListId', []);
                  }
                  handleChange(e);
                  onChangeClass(e.value);
                }}
                onBlur={handleBlur} options={classList} optionLabel="Name" optionValue="Id"
                placeholder="Please select your class"
                disabled={values.boardListId ? !canUpdateCoursePreferences() : true}
                appendTo="self"
              />

              {errors.classlistId && touched.classlistId ?
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.classlistId}</p> : null}
            </div>

            {/* {(selectedClassName.includes('11') || selectedClassName.includes('12')) ?
              <div className="input-form-card">
                <div className="form-label-log">
                  Select your Education Interest (For students of 11th and 12th) <span className="mandiatory-star">*</span>
                </div>

                <div className="course-prefernce-selectbutton">
                  <SelectButton
                    value={values.educationInterestListId}
                    name="educationInterestListId"
                    onChange={(e) => { handleChange(e) }}
                    options={eductinterest}
                    optionLabel="Name"
                    optionValue="Id"
                  />
                </div>
                {errors.educationInterestListId && touched.educationInterestListId ?
                  <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.educationInterestListId}</p> : null}
              </div>
              : ''} */}

            <div className="input-form-card">
              <div className="form-label-log">Choose Your Subjects <span className="mandiatory-star">*</span></div>


              <MultiSelect
                value={Array.isArray(values.subjectListId) ? values.subjectListId : []}
                className="prime-deopdown "
                name="subjectListId"
                onChange={handleChange}
                options={subjectList}
                optionLabel="Name"
                optionValue="Id"
                placeholder="Please select your Subject"
                selectedItemTemplate={(item) => {
                  const safeList = Array.isArray(values.subjectListId) ? values.subjectListId : [];
                  const isLast = safeList.indexOf(item as never) + 1 === safeList.length;
                  return item ? `${subjectList.find(subject => subject.Id === item)?.Name}${isLast ? "" : ", "}` : "Please select your Subject";
                }}
                showSelectAll={true}
                disabled={values.classlistId ? false : true} appendTo="self" />

              {errors.subjectListId && touched.subjectListId ?
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.subjectListId as string}</p> : null}
            </div>


          </div>
          <div className="tw-text-center tw-mt-9 tw-space-x-4">
            <button type="button" onClick={() => setIsEdit(false)} className="ia-btn ia-btn-outline-primary">Go Back</button>
            <button type="submit" className="ia-btn ia-btn-primary">Save & Continue</button>
          </div>

        </form>


      </div>
    </>
  );
};